export default __webpack_public_path__ + "static/media/investors_logo3.b2161011.png";